import React, { useState, useEffect } from 'react';
import { FiX, FiUser, FiCheck } from 'react-icons/fi';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../firebase/config';
import { useAuth } from '../../contexts/AuthContext';
import './ClientAssignmentModal.css';

const ClientAssignmentModal = ({ program, onAssign, onClose }) => {
  const { currentUser } = useAuth();
  const [clients, setClients] = useState([]);
  const [selectedClientId, setSelectedClientId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchClients();
  }, []);

  const fetchClients = async () => {
    try {
      const usersRef = collection(db, 'users');
      const clientsQuery = query(
        usersRef,
        where('trainerId', '==', currentUser.uid),
        where('role', '==', 'client')
      );

      const querySnapshot = await getDocs(clientsQuery);
      const clientsData = [];

      querySnapshot.forEach((doc) => {
        const data = doc.data();
        clientsData.push({
          id: doc.id,
          name: data.displayName || 'Unnamed Client',
          email: data.email
        });
      });

      setClients(clientsData);
    } catch (error) {
      console.error('[ClientAssignmentModal] Error fetching clients:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAssign = () => {
    if (!selectedClientId) {
      alert('Please select a client');
      return;
    }

    const selectedClient = clients.find(c => c.id === selectedClientId);

    const targetClient = {
      clientId: selectedClientId,
      clientName: selectedClient.name,
      clientType: 'individual'
    };

    onAssign(targetClient);
  };

  return (
    <div className="client-assignment-modal">
      <div className="modal-overlay" onClick={onClose}></div>
      <div className="modal-content">
        <div className="modal-header">
          <h2>Assign Program to Client</h2>
          <button className="close-btn" onClick={onClose}>
            <FiX />
          </button>
        </div>

        <div className="modal-body">
          <div className="program-info">
            <h3>{program.name}</h3>
            <p className="program-details">
              {program.numberOfCycles} cycles • {program.sessionsPerCycle} sessions per cycle
            </p>
          </div>

          {loading ? (
            <div className="loading-state">
              <div className="spinner"></div>
              <p>Loading clients...</p>
            </div>
          ) : clients.length === 0 ? (
            <div className="empty-state">
              <FiUser />
              <p>You don't have any clients yet.</p>
              <small>Add clients from the Clients page to assign them programs.</small>
            </div>
          ) : (
            <div className="clients-list">
              <h4>Select a client:</h4>
              {clients.map(client => (
                <div
                  key={client.id}
                  className={`client-card ${selectedClientId === client.id ? 'selected' : ''}`}
                  onClick={() => setSelectedClientId(client.id)}
                >
                  <div className="client-info">
                    <div className="client-avatar">
                      {client.name.charAt(0).toUpperCase()}
                    </div>
                    <div className="client-details">
                      <span className="client-name">{client.name}</span>
                      <span className="client-email">{client.email}</span>
                    </div>
                  </div>
                  {selectedClientId === client.id && (
                    <div className="selected-indicator">
                      <FiCheck />
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button className="cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button
            className="assign-btn"
            onClick={handleAssign}
            disabled={!selectedClientId}
          >
            <FiCheck /> Assign Program
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClientAssignmentModal;
